<template>
  <div class="solution">
    <div class="solu-content">
      <div class="margin-left">
        <div class="main-left-header">
          <span class="line"></span>
          解决方案
        </div>
        <div class="main-left-aside">
          <div
            class="main-left-aside-item"
            v-for="(item, index) in asideList"
            :key="index"
            :class="{ active: tabActive === index }"
            @click="tabTip(index)"
          >
            <span >{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="margin-right" v-if="tabActive === 0">
        <div class="right-header">
          <span class="header-title">电商卖家解决方案</span>
          <span class="header-desc">电商平台发件商家客户，与当地固定网点合作</span>
        </div>
        <div class="right-content">
          <div class="content-padd">
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">与极兔快递合作模式</span>
            </div>
            <div class="ul-desc">
              <ul>
                <li>接入要求：具备API对接能力，可自行打印面单</li>
                <li>发件地固定，有单仓或多仓发货模式，并全由合作网点揽件</li>
                <li>具备面单打印能力，需获取面单号及打印信息，自行打印贴标，由合作网点收派员上门揽件完成寄件服务</li>
                <li>需要获取订单对应的物流轨迹信息</li>
              </ul>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">业务流程介绍</span>
            </div>
            <div class="desc-box">
              <div class="box-title">单仓发货</div>
              <div class="box-fff">
                <div class="box-mide">揽收</div>
                <div class="line-A-C">
                  <span class="line-top"></span>
                </div>
                <div class="box-foot">
                  <div>
                    <div class="box-pic left"></div>
                    <div class="box-title-desc">客户发货仓库A</div>
                  </div>
                  <div class="mide-content">
                    <span>客户下订单</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                    <div class="arrow-left-box marg-top10">
                      <span class="arrow-left"></span>
                    </div>
                    <span>物流轨迹</span>
                  </div>
                  <div>
                    <div class="box-pic mide"></div>
                    <div class="box-title-desc">极兔开放平台</div>
                  </div>
                  <div class="mide-content">
                    <span>商家合作网点揽收</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                  </div>
                  <div>
                    <div class="box-pic right"></div>
                    <div class="box-title-desc">极兔网点A</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="desc-box">
              <div class="box-title">多仓发货</div>
              <div class="box-fff">
                <div class="box-mide">揽收</div>
                <div class="line-A-C">
                  <span class="line-top"></span>
                </div>
                <div class="box-foot">
                  <div>
                    <div class="box-pic left"></div>
                    <div class="box-title-desc">客户发货仓库B</div>
                  </div>
                  <div class="mide-content">
                    <span>客户下订单</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                    <div class="arrow-left-box marg-top10">
                      <span class="arrow-left"></span>
                    </div>
                    <span>物流轨迹</span>
                  </div>
                  <div>
                    <div class="box-pic mide"></div>
                    <div class="box-title-desc">极兔开放平台</div>
                  </div>
                  <div class="mide-content">
                    <span>商家合作网点揽收</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                  </div>
                  <div>
                    <div class="box-pic right"></div>
                    <div class="box-title-desc">极兔网点B</div>
                  </div>
                </div>
                <div class="ge-line"></div>
                <div class="box-mide">揽收</div>
                <div class="line-A-C">
                  <span class="line-top"></span>
                </div>
                <div class="box-foot">
                  <div>
                    <div class="box-pic left"></div>
                    <div class="box-title-desc">客户发货仓库∞</div>
                  </div>
                  <div class="mide-content">
                    <span>客户下订单</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                    <div class="arrow-left-box marg-top10">
                      <span class="arrow-left"></span>
                    </div>
                    <span>物流轨迹</span>
                  </div>
                  <div>
                    <div class="box-pic mide"></div>
                    <div class="box-title-desc">极兔开放平台</div>
                  </div>
                  <div class="mide-content">
                    <span>商家合作网点揽收</span>
                    <div class="arrow-right-box">
                      <span class="arrow-right"></span>
                    </div>
                  </div>
                  <div>
                    <div class="box-pic right"></div>
                    <div class="box-title-desc">极兔网点∞</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">成功案例</span>
            </div>
            <div class="suc-example">
              <el-popover placement="bottom" popper-class="explame-popper" title="" :open-delay="500"
               width="200" trigger="hover" v-for="(item, index) in successList" :key="index" :content="item.desc">
                <div class="example-box" slot="reference">
                  <span class="ex-font ex-title">{{item.title}}</span>
                  <span class="ex-font ex-desc">{{item.desc}}</span>
                </div>
              </el-popover>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">对接流程介绍</span>
            </div>
            <div class="step">
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
              </div>
            </div>
            <div class="step mar-bt20">
              <div class="step-desc">注册极兔快递开放平台进行企业认证</div>
              <div class="step-desc">向网点申请下单客户编码</div>
              <div class="step-desc">运单号及打印信息获取</div>
              <div class="step-desc">客户自行打印面单</div>
              <div class="step-desc">合作网点收派员上门揽件</div>
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <div class="item-desc marg-top15">
                <span class="line-red"></span>
                <span class="desc-font">推荐API</span>
              </div>
              <div><el-button type="primary" icon="el-icon-plus" plain @click="addApi">一键添加到应用调试列表</el-button></div>
            </div>
            <div class="api-card">
              <el-checkbox-group v-model="apiCheck">
                <el-checkbox v-for="item in apiList" :key="item.apiId" :label="item.apiId" :disabled="item.disabled">{{item.apiName}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">面单模板</span>
            </div>
            <div class="print">
              <div class="print-box">
                <div class="print-pic"></div>
                <div><el-button type="primary" icon="el-icon-download" plain @click="downloadOneTemplate(1)">一联模板</el-button></div>
              </div>
              <!-- <div class="print-box">
                <div class="print-pic"></div>
                <div><el-button type="primary" icon="el-icon-download" plain @click="downloadOneTemplate(2)">二联模板</el-button></div>
              </div> -->
              <div class="print-box mar-left210">
                <div class="wechat-pic"></div>
                <div class="wechat-titel">扫描二维码添加飞书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="margin-right" v-if="tabActive === 1">
        <div class="right-header">
          <span class="header-title">物流服务平台解决方案</span>
          <span class="header-desc">借助极兔快递开放平台为B端或C端客户提供物流下单、轨迹等服务</span>
        </div>
        <div class="right-content">
          <div class="content-padd">
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">与极兔快递合作模式</span>
            </div>
            <div class="ul-desc">
              <ul>
                <li>作为下订单、打单、获取轨迹的平台，对接极兔开放平台，获取物流下单、轨迹等服务，服务自身平台的电商卖家等</li>
                <li>借助极兔开放平台的散单、轨迹服务，为寄件消费者提供寄件及物流轨迹查询服务</li>
              </ul>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">业务流程介绍</span>
            </div>
            <div class="desc-box">
              <div class="box-title">散客寄件</div>
              <div class="box-fff mar-bt10">
                <div class="box-mide">4. 称重核价揽收</div>
                <div class="line-A-C">
                  <span class="line-top"></span>
                </div>
                <div style="display: flex">
                  <div>
                    <div class="box-left-content">6. 物流轨迹服务</div>
                    <div class="line-A-B">
                      <span class="line-top"></span>
                    </div>
                  </div>
                  <div>
                    <div class="box-left-content">5. 物流轨迹</div>
                    <div class="line-B-C">
                      <span class="line-top"></span>
                    </div>
                  </div>
                </div>
                <div class="box-foot">
                  <div>
                    <div class="box-pic left2"></div>
                    <div class="box-title-desc">寄件人</div>
                  </div>
                  <div>
                    <div class="box-pic cont2"></div>
                    <div class="box-title-desc">快递平台</div>
                  </div>
                  <div>
                    <div class="box-pic mide2"></div>
                    <div class="box-title-desc">极兔总部</div>
                  </div>
                  <div>
                    <div class="box-pic right2"></div>
                    <div class="box-title-desc">网点收派员</div>
                  </div>
                </div>
                <div style="display: flex">
                  <div>
                    <div class="line-A-B-bottom">
                      <span class="line-bottom"></span>
                    </div>
                    <div class="box-left-content">1. 填写订单信息</div>
                  </div>
                  <div>
                    <div class="line-B-C-bottom">
                      <span class="line-bottom"></span>
                    </div>
                    <div class="box-left-content">2. 客户下订单</div>
                  </div>
                  <div>
                    <div class="line-B-C-bottom">
                      <span class="line-bottom"></span>
                    </div>
                    <div class="box-left-content">3. 极兔订单调度</div>
                  </div>
                </div>
              </div>
              <div class="box-title">多仓发货</div>
              <div class="box-fff">
                <img src="../../assets/images/solution/0630.png" alt="多仓发货">
              </div>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">成功案例</span>
            </div>
            <div class="suc-example">
              <el-popover placement="bottom" popper-class="explame-popper" title="" :open-delay="500"
               width="200" trigger="hover" v-for="(item, index) in successList1" :key="index" :content="item.desc">
                <div class="example-box" slot="reference">
                  <span class="ex-font ex-title">{{item.title}}</span>
                  <span class="ex-font ex-desc">{{item.desc}}</span>
                </div>
              </el-popover>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">对接流程介绍</span>
            </div>
            <div class="step">
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
                  <div class="line"></div>
              </div>
              <div class="step-item">
                  <div class="step-circle"><div class="step-red-circel"></div></div>
              </div>
            </div>
            <div class="step mar-bt20">
              <div class="step-desc">注册极兔快递开放平台进行企业认证</div>
              <div class="step-desc">向网点申请下单客户编码</div>
              <div class="step-desc">运单号及打印信息获取</div>
              <div class="step-desc">客户自行打印面单</div>
              <div class="step-desc">合作网点收派员上门揽件</div>
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <div class="item-desc marg-top15">
                <span class="line-red"></span>
                <span class="desc-font">推荐API</span>
              </div>
              <div><el-button type="primary" icon="el-icon-plus" plain @click="addApi">一键添加到应用调试列表</el-button></div>
            </div>
            <div class="api-card">
              <el-checkbox-group v-model="apiCheck">
                <el-checkbox v-for="item in apiList" :key="item.apiId" :label="item.apiId" :disabled="item.disabled">{{item.apiName}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="item-desc">
              <span class="line-red"></span>
              <span class="desc-font">面单模板</span>
            </div>
            <div class="print">
              <div class="print-box">
                <div class="print-pic"></div>
                <div><el-button type="primary" icon="el-icon-download" plain @click="downloadOneTemplate(1)">一联模板</el-button></div>
              </div>
              <!-- <div class="print-box">
                <div class="print-pic"></div>
                <div><el-button type="primary" icon="el-icon-download" plain @click="downloadOneTemplate(2)">二联模板</el-button></div>
              </div> -->
              <div class="print-box mar-left210">
                <div>商务洽谈请联系：</div>
                <div>ennis.wu@jtexpress.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  data() {
    return {
      asideList: [
        { label: '电商卖家解决方案' },
        { label: '物流服务平台解决方案' }
      ],
      successList: [
        { title: '商家', desc: '某电商平台发货商家，日均发货量10000+，商品从上海、武汉、深圳三个仓库发货，有商家自己研发的系统' },
        { title: '业务痛点', desc: '订单下发时，订单信息无法直接给到当地网点，并且商家客服无法实时获取订单相关物流轨迹。' },
        { title: '合作介绍', desc: '此发件商家先与三个发货仓库当地的网点取得联系并申请订单客户编码，同时注册极兔开发平台进行企业认证，对接创建订单、物流轨迹推送接口，提供三个客户编码和开放平台相关接口的apiAccount绑定，接口上线后，商家通过创建订单接口下单即可，相应合作网点上门揽收包裹，当订单相关物流信息变更时，极兔自动推送物流给商家系统' }
      ],
      successList1: [
        { title: '物流服务平台', desc: '某物流服务平台，致力于为普通消费者提供快递寄收服务。用户为来自五湖四海的各种地点，需要依托于快递公司提供的寄件及派单服务。' },
        { title: '业务痛点', desc: '发货地不固定，且没有固定的客户，揽收的网点根据发件地址调度，需要轨迹相关的功能来提高用户粘性。' },
        { title: '合作介绍', desc: '此物流服务平台无需和网点取得联系，可联系总部达成合作，同时注册极兔开发平台进行企业认证，对接创建订单、物流轨迹查询、推送接口。接口上线后，平台可通过创建订单接口进行下单，由极兔系统负责调度到用户最近的网点，网点分配快递员上门揽收包裹，当订单相关物流信息变更时，极兔自动推送物流给平台，由平台展示给消费者。' }
      ],
      tabActive: 0,
      apiCheck: [],
      apiList: [
        { apiId: '10000000011299', apiName: '创建订单', disabled: false },
        { apiId: '10000000021299', apiName: '订单取消', disabled: false },
        { apiId: '10000000031299', apiName: '查询订单', disabled: false },
        { apiId: '10000000001299', apiName: '物流轨迹查询', disabled: false },
        { apiId: '10000001101299', apiName: '物流轨迹推送', disabled: false },
        { apiId: '10000000201299', apiName: '获取轨迹更新', disabled: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'token', 'appId']),
  },
  mounted() {
    if (this.token) {
      this.getApiManagementList()
    }
  },
  methods: {
    ...mapActions(['LOGIN_INIT_APPID']),
     async getApiManagementList() {
      const formData = new FormData()
      formData.append('appId', this.appId)
      const { code, data } = await this.$API.managementList(formData)
      if (code === RESPONSE_SUCCESS) {
        if (data.debugList) {
          data.debugList.forEach(v => {
            this.apiList.forEach(m => {
              if(v.interfaceId === m.apiId) {
                m.disabled = true
              }
            })
          })
        }
        if (data.waitingList) {
          data.waitingList.forEach(v => {
            this.apiList.forEach(m => {
              if(v.interfaceId === m.apiId) {
                m.disabled = true
              }
            })
          })
        }
        if (data.completedList) {
          data.completedList.forEach(v => {
            this.apiList.forEach(m => {
              if(v.interfaceId === m.apiId) {
                m.disabled = true
              }
            })
          })
        }
      }
    },
    /**
     * @description 添加到应用调试列表
     */
    async addApi() {
      if (!this.token) {
        this.$message({
          type: 'info',
          message: '请登录',
          duration: 1000
        })
        return this.$router.push({ name: 'Login' })
      }
      if (!this.appId) {
        const res = await this.$API.appList()
        if (res.code === RESPONSE_SUCCESS) {
          if (!res.data[0].id) {
            return this.$message.error('请重新登录')
          }
          this.LOGIN_INIT_APPID({ appId: res.data[0].id })
        }
      }
      const { code, msg } = await this.$API.addInterface({ idList: this.apiCheck, appId: this.appId })
      if (code === RESPONSE_SUCCESS) {
        this.$message.success('添加成功')
        this.getApiManagementList()
      } else {
        this.$message.error(msg)
      }
    },
    tabTip(index) {
      let event = 'Solution_Logistics'
      if (index === 0) {
        event = 'Solution_Electronic_Commerce'
      } else {
        event = 'Solution_Logistics'
      }
      window._hmt.push(['_trackCustomEvent', event]);
      this.tabActive = index
      this.apiCheck = []
      document.documentElement.scrollTop = 0
    },
    //下载模板
    async downloadOneTemplate(type){
      const elink = document.createElement('a')
      elink.style.display = 'none'
      if(type === 1){
        elink.href = this.$API.downloadOneTemplate
      }else if(type === 2){
        elink.href = this.$API.downloadTwoTemplate
      }
      elink.setAttribute('download', name)
      document.body.appendChild(elink)
      elink.click()
    }
  }
}
</script>
<style>
.explame-popper {
  border-radius: 15px !important;
}
</style>
<style lang="scss" scoped>
.solution {
  background: #f4f5f7;
  // height: calc(100% - 64px);
  width: 100%;
  padding-top: 64px;
  .solu-content {
    padding: 20px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .margin-left {
      width: 240px;
      //height: 275px;
      overflow-y: auto;
      box-sizing: border-box;
      padding-bottom: 20px;
      background: #fff;
      border-radius: 6px;
      position: fixed;
      .main-left-header {
        position: relative;
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-size: 26px;
        font-weight: 900;
        line-height: 26px;
        padding: 22px 0 22px 20px;
        box-sizing: border-box;
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
      }
      .main-left-aside {
        box-sizing: border-box;
        .main-left-aside-item {
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
          padding-top: 34px;
          padding-left: 32px;
          cursor: pointer;
          &.first {
            margin-top: 47px;
          }
          &.active {
            color: $theme-color;
            font-weight: 600;
          }
        }
      }
    }
    .margin-right {
      width: calc(100% - 260px);
      margin-left: 260px;
      background: #fff;
      border-radius: 6px;
      .right-header {
        padding: 20px 24px;
        span {
          display: inline-block;
        }
        .header-title {
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          text-align: left;
          color: #2b2b2b;
          margin-right: 24px;
        }
        .header-desc {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 400;
          text-align: left;
          color: #2b2b2b;
        }
      }
      .right-content {
        margin-top: 5px;
        border-top: 1px solid #D9D9D9;
        .content-padd {
          padding: 24px;
          .item-desc {
            height: 24px;
            line-height: 24px;
            margin: 20px 0;
            span {
              display: inline-block;
            }
            .desc-font {
              font-size: 16px;
              font-weight: 600;
              font-family: PingFangSC, PingFangSC-Medium;
              color: #2b2b2b;
              margin-left: 10px;
            }
          }
          .ul-desc {
            font-size: 14px;
            font-weight: 400;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #2b2b2b;
            li {
              height: 24px;
              line-height: 24px;
            }
          }
          .desc-box {
            margin-top: 12px;
            margin-bottom: 50px;
          }
          .box-title {
            height: 40px;
            background: #f2f2f2;
            border-radius: 6px 6px 0px 0px;
            text-align: center;
            line-height: 40px;
            color: #2b2b2b;
          }
          .box-fff {
            min-height: 258px;
            border: 2px solid #f2f2f2;
            border-radius: 0 0 6px 6px;
            border-top: none;
            padding-bottom: 30px;
            .ge-line {
              height: 1px;
              background-color: #D9D9D9;
              margin-top: 20px;
            }
            .line-A-C {
              width: 700px;
              margin: 13px auto 0px;
            }
            .line-A-B {
              width: 230px;
              margin: 13px 0 0 100px;
            }
            .line-B-C {
              width: 230px;
              margin: 13px 0 0 10px;
            }
            .line-A-C, .line-A-B, .line-B-C {
              border: 1px dashed #979797;
              height: 19px;
              position: relative;
              border-bottom: none;
              border-radius: 6px 6px 0px 0px;
              .line-top {
                display: block;
                width: 5px;
                border: 1px dashed #979797;
                position: absolute;
                top: 15px;
                left: -6px;
                transform: rotate(234deg);
              }
            }
            .line-B-C-bottom {
              margin: 13px 0 0 10px;
            }
            .line-A-B-bottom {
              margin: 13px 0 0 100px;
            }
            .line-A-B-bottom,.line-B-C-bottom {
              width: 230px;
              border-radius: 0 0 6px 6px;
              border: 1px dashed #979797;
              border-top: none;
              height: 19px;
              position: relative;
              .line-bottom {
                display: block;
                width: 5px;
                border: 1px dashed #979797;
                position: absolute;
                top: 2px;
                right: -6px;
                transform: rotate(247deg);
              }
            }
            .box-left-content {
              padding-left: 40%;
            }
            .box-mide {
              text-align: center;
            }
            .box-mide,.box-left-content {
              padding-top: 18px;
              font-size: 14px;
              color: #2b2b2b;;
            }
            .box-foot {
              display: flex;
              justify-content: space-between;
              padding: 0 20px;
              .box-pic {
                width: 158px;
                height: 158px;
              }
              .left,.mide,.right,.left2,.mide2,.cont2,.right2 {
                background-size: 158px 158px;
              }
              .left {
                background: url('../../assets/images/solution/car.png') no-repeat center center;
              }
              .mide {
                background: url('../../assets/images/solution/group.png') no-repeat center center;
              }
              .right {
                background: url('../../assets/images/solution/carB.png') no-repeat center center;
              }
              .left2 {
                background: url('../../assets/images/solution/page2-one.png') no-repeat center center;
              }
              .cont2 {
                background: url('../../assets/images/solution/page2-two.png') no-repeat center center;
              }
              .mide2 {
                background: url('../../assets/images/solution/page2-three.png') no-repeat center center;
              }
              .right2 {
                background: url('../../assets/images/solution/page2-four.png') no-repeat center center;
              }
              .box-title-desc {
                width: 158px;
                text-align: center;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Light;
                color: #2b2b2b;
              }
              .mide-content {
                padding-top: 50px;
                font-size: 14px;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .arrow-right-box {
                  width: 70px;
                  border: 1px dashed #979797;
                  margin-top: 10px;
                  position: relative;
                  .arrow-right {
                    border: 1px dashed #979797;
                    display: block;
                    width: 5px;
                    position: absolute;
                    transform:rotate(213deg);
                    top: -4px;
                    right: 0;
                  }
                }
                .arrow-left-box {
                  width: 70px;
                  border: 1px dashed #979797;
                  margin-bottom: 10px;
                  position: relative;
                  .arrow-left {
                    border: 1px dashed #979797;
                    display: block;
                    width: 5px;
                    position: absolute;
                    transform:rotate(213deg);
                    top: 2px;
                    left: 0;
                  }
                }
                span {
                  display: block;
                }
              }
            }
          }
          .suc-example {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            .example-box {
              padding: 14px 20px 0px 20px;
              width: 245px;
              height: 105px;
              border: 2px solid #f2f2f2;
              border-radius: 6px;
              .ex-title {
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 600;
              }
              .ex-font {
                font-size: 14px;
                color: #2b2b2b;
              }
              .ex-desc {
                font-family: PingFangSC, PingFangSC-Light;
                font-weight: 300;
                width: 200px;
                text-overflow: ellipsis;
                overflow:hidden;
                white-space: nowrap;
                padding: 16px 0 15px;
                text-align: center;
                text-indent: 28px;
              }
              .ex-look {
                color: #4071FF;
                font-size: 12px;
                width: 30px;
              }
              .ex-look:hover {
                cursor: pointer;
              }
              span {
                display: block;
              }
            }
            .example-box:hover {
              cursor: pointer;
              box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
            }
          }
          .step {
            display: flex;
            .step-item {
              display: flex;
              align-items: center;
            }
            .step-circle {
              width: 12px;
              height: 12px;
              background: rgba(230,0,0,0.20);
              border-radius: 50%;
              position: relative;
              .step-red-circel {
                width: 6px;
                height: 6px;
                background: #e60000;
                border-radius: 50%;
                position: absolute;
                top: 3px;
                left: 3px;
              }
            }
            .line {
              margin: 0 10px;
              width: 143px;
              height: 1px;
              background: #e60000;
            }
            .step-desc {
              width: 150px;
              margin-right: 26px;
              margin-top: 10px;
              font-size: 14px;
              font-weight: 400;
              font-family: PingFangSC, PingFangSC-Regular;
            }
          }
          .api-card {
            padding: 14px 20px;
            border: 2px solid #f2f2f2;
            border-radius: 6px;
          }
          .print {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            padding: 0 50px;
            .print-box {
              .print-pic {
                width: 132px;
                height: 132px;
                background: url('../../assets/images/solution/print.png') no-repeat center center;
                background-size: 132px 132px;
              }
              .wechat-pic {
                width: 102px;
                height: 102px;
                background: url('../../assets/images/newHome/phoneus.jpg') no-repeat center center;
                background-size: 102px 102px;
              }
              .wechat-titel {
                width: 100px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                color: #666666;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .line-red {
      width: 3px;
      height: 18px;
      background: #e60000;
      border-radius: 2px;
    }
  }
}
.marg-top10 {
  margin-top: 5px;
}
.mar-bt10 {
  margin-bottom: 50px;
}
.mar-bt20 {
  margin-bottom: 20px;
}
.marg-top15 {
  margin: 30px 0 20px 0 !important;
}
::v-deep .el-checkbox {
  width: 150px;
  margin-bottom: 20px;
}
.mar-left210{
  margin-left: 210px;
}
</style>
